export default function getQueryString(queryString: Object){
    return `?` + Object.entries(queryString).filter((el)=> el[1] != null && el[1] !== '').map((el)=> el[1] && `${el[0]}=${el[1]}`).join('&')
}